import React from "react";
import {Space, Tag, Typography} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Translate} from "../../../../../hooks/translate.hook";
import {
    HealthCheckerCheck,
    HealthCheckerGroupOption,
} from "../../../../../models/health-checker/health-checker";
import {formatHealthCenterDateTime} from "../../../health-center.helpers";
import {SmartColumn} from "../../../../common/smart-table/smart-table.model";
import {FieldType} from "../../../../common/smart-table/smart-table.field-config";
import {HealthCenterCheckStatus} from "./checks.status";

const {Text} = Typography;

export const columnsFactory = (t: Translate): SmartColumn<HealthCheckerCheck>[] => {
    return [
        {
            name: "status",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECKS.STATUS", {defaultValue: "Status"}),
            type: FieldType.ENUM,
            filterable: true,
            render: (status) => <HealthCenterCheckStatus status={status} />,
        },
        {
            name: "checkerName",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECKS.CHECKER-NAME", {defaultValue: "Checker"}),
            type: FieldType.STRING,
            filterable: true,
            render: (checkerName: string, check) => (
                <Space direction="vertical" size={0}>
                    <Text strong>{checkerName}</Text>
                    <Text type="secondary" className="health-center-checks__id">#{check.id}</Text>
                </Space>
            ),
        },
        {
            name: "group",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECKS.GROUP", {defaultValue: "Group"}),
            type: FieldType.CUSTOM,
            render: (group: HealthCheckerGroupOption) => (
                <Tag className="health-center-checks__group" color="blue">
                    {group.name}
                </Tag>
            ),
        },
        {
            name: "hours",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECKS.HOURS", {
                defaultValue: "Hours",
            }),
            type: FieldType.INTEGER_ARRAY
        },
        {
            name: "lastCheckedAt",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECKS.LAST-CHECKED-AT", {defaultValue: "Last checked"}),
            type: FieldType.DATETIME,
            render: (value: string) => (
                <Text className="health-center-checks__date">{formatHealthCenterDateTime(value)}</Text>
            ),
        },
        {
            name: "nextCheckAt",
            visibleName: t("HEALTH-CENTER.SETTINGS.CHECKS.NEXT-CHECK-AT", {defaultValue: "Next check"}),
            type: FieldType.DATETIME,
            render: (value: string) => (
                <Text className="health-center-checks__date health-center-checks__date--next">
                    <FontAwesomeIcon icon={["fas", "clock"]} /> {formatHealthCenterDateTime(value)}
                </Text>
            ),
        },
    ];
};
